import * as $ from 'jquery';
export function registerAutoFocus() {
    // Every time a modal is shown, if it has an autofocus element, focus on it.
    $(document).on('shown.bs.modal', function () {
        $(this).find('[autofocus]').focus();
    });
}
